import React from "react";
import {NavLink, Redirect, Route, Switch} from "react-router-dom";
import styled from "styled-components";
import {TopWapWidget} from "../personal/widget/top_wap";
import {BottomWidget} from "./bottom_list";


export enum CLAIMLIST {
    claimListAdmin = "claimListAdmin",
    claimListPay = "claimListPay",
    claimListChallenge = "claimListChallenge",

}
export const AdminPage: React.FC = () => {
    return (
        <div>
            <Switch>
                <Route path="/">
                    <WapStyle>
                        <TopWapWidget/>
                        <div style={{height: '30px'}}/>
                        <TitleStyle>
                            <TabCellStyle to={'/admin/'+CLAIMLIST.claimListAdmin}>Claims</TabCellStyle>
                            <TabCellStyle to={'/admin/'+CLAIMLIST.claimListPay}>Pay</TabCellStyle>
                            <TabCellStyle to={'/admin/'+CLAIMLIST.claimListChallenge}>Challenge</TabCellStyle>
                        </TitleStyle>
                        <Switch>
                            <Route path="/admin/:type" component={BottomWidget}/>
                            <Redirect to="/admin/claimListAdmin"/>
                        </Switch>
                    </WapStyle>

                </Route>
                {/*<Route path="/personal/arbitration" component={ChallengePage}/>*/}
                <Redirect to="/"/>

            </Switch>

        </div>
    );
}

const TitleStyle = styled.div`
  background: white;  border-radius: 10px 10px 0 0;

  height: 50px;
  display: flex;
  align-items: center;
`
const TabCellStyle = styled(NavLink)`
  height: 50px;
  border-radius: 10px 10px 0 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-weight: 400;
  cursor: pointer;
  padding: 0 30px;
  color: #222222;
  font-size: 16px;

  &.active {
    background: #E4EEFD;
    transform: translate(0, 0px);
  }

`;

const WapStyle = styled.div`
  padding: 30px;
  box-sizing: border-box;
  border-radius: 10px;
  background-color: #E5E8F5;
`
